import config from '../config';

export function buildWebSocketURL(baseUrl, params = {}) {
  const filteredEntries = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});

  try {
    const url = new URL(baseUrl);
    Object.entries(filteredEntries).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
    return url.toString();
  } catch (error) {
    const queryString = new URLSearchParams(filteredEntries).toString();
    if (!queryString) {
      return baseUrl;
    }
    const hasQuery = baseUrl.includes('?');
    const endsWithSlash = baseUrl.endsWith('/');
    const separator = hasQuery ? '&' : (endsWithSlash ? '' : '/') + '?';
    return `${baseUrl}${separator}${queryString}`;
  }
}

export async function requestWebSocketTicket({ project, guide, remoteUploader = false, signal } = {}) {
  const token = localStorage.getItem('token');
  if (!token) {
    return null;
  }

  const response = await fetch('/api/v1/auth/ws-ticket', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ project, guide, remoteUploader }),
    signal
  });

  let data = {};
  try {
    data = await response.json();
  } catch (error) {
    data = {};
  }

  if (response.status === 401) {
    window.location.href = `${config.prefixPath}/login?externalError=unauthorized`;
    const authError = new Error(data?.message || 'Authentication required.');
    authError.status = 401;
    throw authError;
  }

  if (!response.ok) {
    const requestError = new Error(data?.message || 'Unable to create a websocket ticket.');
    requestError.status = response.status;
    throw requestError;
  }

  if (!data?.ticket) {
    const invalidResponseError = new Error('Unable to create a websocket ticket.');
    invalidResponseError.status = 500;
    throw invalidResponseError;
  }

  return data;
}

export async function buildAuthenticatedWebSocketURL(baseUrl, options = {}) {
  const ticketResponse = await requestWebSocketTicket(options);
  if (!ticketResponse?.ticket) {
    return null;
  }

  return buildWebSocketURL(baseUrl, {
    d: '0',
    project: options.project,
    guide: options.guide,
    ...(options.remoteUploader ? { remoteUploader: 'true' } : {}),
    ticket: ticketResponse.ticket
  });
}
